import { DatePipe } from '@angular/common';
import { TabService } from './../../../../services/tab.service';
import { TranslateService } from '@ngx-translate/core';
import { OnInit, Component, Input } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { Tache } from '../../../../models/tache.model';

@Component({
  selector: 'app-tabActionsPassees',
  templateUrl: './tabActionsPassees.component.html',
  styleUrls: ['./tabActionsPassees.component.scss'],
})
export class TabActionsPasseesComponent implements OnInit {

  @Input() taches: Tache[];
  testString: string;
  defaultOrdre: number;
  source: LocalDataSource;
  constructor( private datePipe: DatePipe, private translate: TranslateService, private tabService: TabService) {

  }
  ngOnInit() {
  }

  settings = {
    actions: false,
    columns: {
      'typeTache': {
        title: this.translate.instant('ROOM'),
        editable: false,
        type: 'string',
        valuePrepareFunction: (value) => {
          value = this.translate.instant('ROOM_' + value.typeSalleId);
          return value;
        },
        compareFunction: (direction: any, a: any, b: any) => {
          a = a.typeSalleId;
          b = b.typeSalleId;
          return this.tabService.compareFunction(direction, a, b);
        },
        filterFunction: (value: any, search: string) => {
          value = this.translate.instant('ROOM_' + value.typeSalleId).toUpperCase();
          return this.tabService.filterFunction(value, search);
        },
      },
      'typeTacheId': {
        title: this.translate.instant('TASK_TYPE'),
        editable: false,
        type: 'string',
        valuePrepareFunction: (value) => {
          value = this.translate.instant('TASK_' + value);
          return value;
        },
        filterFunction: (value: any, search: string) => {
          value = this.translate.instant('TASK_' + value).toUpperCase();
          return this.tabService.filterFunction(value, search);
        },
      },
      recette: {
        title: this.translate.instant('RECIPE'),
        type: 'date',
        editable: false,
        valuePrepareFunction: (value) => {
          value = this.translate.instant(value.libelle_plante);
          return value;
        },
        compareFunction:(direction: any, a: any, b: any) => {
          a = a.typeSalleId;
          b = b.typeSalleId;
          return this.tabService.compareFunction(direction, a, b);
        },
        filterFunction: (value: any, search: string) => {
          value = this.translate.instant(value.libelle_plante).toUpperCase();
          return this.tabService.filterFunction(value, search);
        },
      },
      daterealisationtache: {
        title: this.translate.instant('EXECUTION_DATE'),
        type: 'date',
        editable: false,
        valuePrepareFunction: (date) => { 
          var raw = new Date(date);
  
          var formatted = this.datePipe.transform(raw, 'dd/MM/yyyy hh:mm');
          return formatted; 
        }
      },
      utilisateur: {
        title: this.translate.instant('USER'),
        type: 'date',
        editable: false,
        valuePrepareFunction: (value) => {
          value = this.translate.instant(value.nom);
          return value;
        },
        compareFunction: (direction: any, a: any, b: any) => {
          a = a.nom;
          b = b.nom;
          return this.tabService.compareFunction(direction, a, b);
        },
        filterFunction: (value: any, search: string) => {
          value = this.translate.instant(value.nom).toUpperCase();
          return this.tabService.filterFunction(value, search);
        },
      },
    },
  };
}


